import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'smex-app-cfn-session-expired-dialog',
    templateUrl: './session-expired-dialog.component.html',
    styleUrls: ['./session-expired-dialog.component.scss'],
})
export class SessionExpiredDialogComponent {
    constructor(public dialogRef: MatDialogRef<SessionExpiredDialogComponent>) {}

    onReconnect() {
        this.dialogRef.close();
    }
}
